/**
 * DP Light's official logo (D-137): the mark, and the DPLIGHT® wordmark cut from the same
 * artwork — white on the navy sidebar, black on the light sign-in card.
 */
export function Logo({ size = 40, tone = 'light', className = '' }: { size?: number; tone?: 'light' | 'dark'; className?: string }) {
  return (
    <span className={`inline-flex items-center gap-2 ${className}`} role="img" aria-label="DPLIGHT">
      <img src="/brand/dplight-mark.png" alt="" height={size} style={{ height: size, width: 'auto' }} className="shrink-0" />
      <img
        src={tone === 'light' ? '/brand/dplight-wordmark-white.png' : '/brand/dplight-wordmark.png'}
        alt=""
        style={{ height: Math.round(size * 0.4), width: 'auto' }}
        className="shrink-0"
      />
    </span>
  )
}
